<mat-card class="cardWithShadow" style="margin:0; height:100%; overflow:hidden; border-radius:0;">

  <!-- HEADER -->
  <mat-card-header class="w-100 d-block p-0" style="background-color:#1e293b; border-bottom:3px solid #5d87ff;">
    <mat-card-title>
      <div class="w-100 d-flex" style="background:#0f172a;">
        <span style="display:flex; align-items:center; margin-left:15px; color:#1bbaee; font-size:14px;">
          {{ "Obligations NF525 – Sauvegarde & Archivage fiscal" | translate }}
        </span>

        <button class="m-l-auto" mat-icon-button (click)="matDialogRef.close();">
          <i-tabler name="x" class="icon-18" style="color:#1bb3e6;"></i-tabler>
        </button>
      </div>
    </mat-card-title>

    <mat-card-subtitle style="background:#dee8ff; color:black;" class="p-t-16 p-b-16">
      <div class="d-flex">
        <div class="d-flex flex">
          <div style="border-right:2px solid #1855d5; margin-right:15px;">
            <button mat-icon-button>
              <i-tabler name="shield-check" class="icon-24" style="color:#1cc8ff;"></i-tabler>
            </button>
          </div>

          <div class="d-grid">
            <span class="f-w-700">Information réglementaire – Responsabilité de l’administrateur</span>
            <span style="padding-top:6px; font-size:13px; color:#6b7280; font-weight:600;">
              NF525 • Article L102 B du Livre des Procédures Fiscales
            </span>
          </div>
        </div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>

  <!-- CONTENT -->
  <mat-card-content style="flex:1; padding:0; overflow:auto;">

    <p style="font-weight:800; text-align:center; color:#b42318; background:#fde7e7; margin:0; padding:14px;">
      Obligations relatives à la sauvegarde et à l’archivage des données fiscales
    </p>

    <div style="padding:16px 18px;">

      <p style="margin:0 0 10px 0; font-weight:700; color:#0f172a;">
        Conformément à la norme NF525 et à l’article L102 B du Livre des Procédures Fiscales,
        vous êtes responsable de la conservation, de l’archivage et de la disponibilité de vos données fiscales.
      </p>

      <p style="margin:0 0 14px 0; color:#334155; font-weight:600;">
        Les données doivent être conservées pendant une durée minimale de
        <b>6 années</b>, dans des conditions garantissant leur
        <b>intégrité</b>, leur <b>lisibilité</b> et leur <b>accessibilité</b>.
      </p>

      <!-- OBLIGATIONS -->
      <div style="border:1px solid #dbeafe; background:#f8fbff; border-radius:10px; padding:12px; margin-bottom:14px;">
        <div style="display:flex; gap:10px;">
          <i-tabler name="database" class="icon-22" style="color:#2563eb;"></i-tabler>

          <div>
            <div style="font-weight:800; color:#0f172a; margin-bottom:8px;">Vos obligations</div>

            <div style="display:grid; gap:8px; font-weight:600; color:#334155;">
              <div>• Mettre en place un <b>système de sauvegarde régulier et sécurisé</b>.</div>
              <div>• Conserver les données sur un <b>support distinct et fiable</b>.</div>
              <div>• Garantir une <b>conservation minimale de 6 ans</b>.</div>
              <div>• Vérifier périodiquement la <b>lisibilité et l’intégrité</b> des sauvegardes.</div>
              <div>• Pouvoir <b>présenter les données à l’administration fiscale</b> en cas de contrôle.</div>
            </div>
          </div>
        </div>
      </div>

      <!-- IMPORTANT -->
      <div style="border:1px solid #fecaca; background:#fff7f7; border-radius:10px; padding:12px;">
        <div style="display:flex; gap:10px;">
          <i-tabler name="alert-triangle" class="icon-22" style="color:#b42318;"></i-tabler>

          <div>
            <div style="font-weight:800; color:#7f1d1d; margin-bottom:6px;">
              Information importante
            </div>

            <div style="font-weight:650; color:#7f1d1d; line-height:20px;">
              L’absence de sauvegarde ou une sauvegarde non exploitable peut entraîner une perte définitive des données
              et une non-conformité réglementaire.
              <br /><br />
              <b>Edition Cauris ne pourra être tenue responsable</b> d’un défaut de sauvegarde ou d’archivage relevant
              de la responsabilité de l’utilisateur.
            </div>
          </div>
        </div>
      </div>

      <!-- CONFIRMATION -->
      <div style="border-top:1px dashed #cbd5e1; padding-top:14px; margin-top:14px;">
        <mat-checkbox [(ngModel)]="nf525Acknowledged" style="font-weight:800;">
          J’ai lu et compris mes obligations de conservation et d’archivage des données
          conformément à la norme NF525 (durée minimale de 6 ans).
        </mat-checkbox>

        <div *ngIf="!nf525Acknowledged" style="margin-top:6px; font-size:12px; color:#b42318; font-weight:700;">
          La validation est obligatoire pour continuer.
        </div>
      </div>

    </div>

    <div style="height:90px; display:flex; background:linear-gradient(180deg, rgba(93,135,255,0.12), transparent);">
      <i-tabler name="cloud-lock" class="d-flex"
        style="color:#5d87ff; align-items:center; width:128px; text-align:center; margin:auto;">
      </i-tabler>
    </div>

  </mat-card-content>

  <!-- ACTIONS -->
  <mat-card-actions class="d-block m-0 p-0" style="background:#ffffff; border-top:3px solid #5d87ff;">
    <div class="d-flex w-100" style="padding:10px; gap:10px;">
      <button mat-stroked-button
              (click)="matDialogRef.close()"
              style="flex:1; font-weight:800;">
        {{ "FERMER" | translate }}
      </button>

      <button mat-flat-button
              color="primary"
              [disabled]="!nf525Acknowledged"
              (click)="doConfirmNF525()"
              style="flex:1; font-weight:900;">
        {{ "J'AI COMPRIS" | translate }}
      </button>
    </div>
  </mat-card-actions>

</mat-card>